(() =>
{
	const allInputs = document.querySelectorAll('.input--text');
	const groupActiveClass = 'input__group--active';

	[...allInputs].forEach(input =>
	{
		// We expect the parent node to have a class named 'input__group'
		// this class should provide active styles for all children within
		let { parentNode } = input;

		if (parentNode.classList.contains('input__group'))
		{

			// Check on page load (added for the search form)
			let hasText = input.value != '';
			if (hasText)
			{
				parentNode.classList.add(groupActiveClass);
			}

			input.addEventListener('input', e =>
			{
				let hasText = e.target.value != '';
				if (hasText)
				{
					parentNode.classList.add(groupActiveClass);
				}
			});

			input.addEventListener('focus', () =>
			{
				parentNode.classList.add(groupActiveClass);
			});

			input.addEventListener('focusout', e =>
			{
				if (e.target.value == '')
				{
					parentNode.classList.remove(groupActiveClass);
				}
			});

		}
	});
})();
